import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';
import {CalendarTranslate} from '../../../../../../models/calendarTranslate.model';
import {CalendarTranslateService} from '../../../../../../modules/UIKit/services/calendarTranslate.service';
import {PromotionMessageLayoutService} from '../../../../../../services/promotion/promotion-message-layout.service';

@Component({
  selector: 'app-tab-layout',
  template: `
    <form [formGroup]="formData">
      <div style="margin-top: 50px"
           formArrayName="layoutList"
           *ngFor="let item of controls(); let i=index">
        <div [formGroupName]="i.toString()">
          <button
            pButton
            type="button"
            class="k-generic-btn"
            icon="fa fa-minus-circle"
            iconPos="left"
            label="{{ 'common.delete' | translate }}"
            (click)="deletePrivacyList(i)">
          </button>
          <div class="ui-g ui-fluid master-data customer-cards-info">
            <p-panel class="ui-g-12 ui-md-12">
              <p-header>
                <div style="height: 20px">
                  <div style="text-align: center; font-size: medium; font-weight: bold">{{ 'promotion.messageLayout' | translate }}</div>
                </div>
              </p-header>
              <div class="ui-g-12 ui-fluid">
                <div [kv-form-element]="{ label: 'promotion.touchPoint', md: '6' }">
                  <p-dropdown
                    [options]="touchPoints"
                    formControlName="ochannel_id">
                  </p-dropdown>
                </div>
                <div [kv-form-element]="{ label: 'layout.layout', md: '6' }">
                  <p-dropdown
                    [options]="layouts"
                    formControlName="message_layout_id">
                  </p-dropdown>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
                <div [kv-form-element]="{ label: 'promotion.startVisibility', md: '3'}">
                  <p-calendar
                    class="over"
                    [showIcon]="true"
                    formControlName="start_visibility_date"
                    [readonlyInput]="false"
                    [dateFormat]="calendarTranslate.dateFormat">
                  </p-calendar>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
                <div [kv-form-element]="{ label: 'promotion.endVisibility', md: '3'}">
                  <p-calendar
                    class="over"
                    [showIcon]="true"
                    formControlName="end_visibility_date"
                    [readonlyInput]="false"
                    [dateFormat]="calendarTranslate.dateFormat">
                  </p-calendar>
                </div>
                <div [kv-form-element]="{ label: '', md: '2'}"></div>
              </div>
            </p-panel>
            <div class="ui-g-12 text-right">
              <button
                pButton
                type="submit"
                class="k-generic-btn"
                icon="fa fa-floppy-o"
                iconPos="left"
                label="{{ 'common.save' | translate }}"
                (click)="save(i)">
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-plus-circle"
      label="{{'common.add' | translate}}"
      (click)="addPrivacy()">
    </button>
  `,
  providers: [
    CalendarTranslateService
  ]
})
export class TabLayoutComponent implements OnInit {

  @Input() touchPoints;
  @Input() layouts;
  @Input() editMessage;

  layoutList: FormArray;
  formData: FormGroup;
  today: Date = new Date();
  calendarTranslate: CalendarTranslate;

  constructor( private fb: FormBuilder,
               private srvCalendarTranslate: CalendarTranslateService,
               private svcMessageLayout: PromotionMessageLayoutService,
  ) {
    this.srvCalendarTranslate.pCalendar.subscribe(c => {
      this.calendarTranslate = c
    });
  }

  controls() {
    return (<any>this.formData.get('layoutList')).controls;
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    this.formData = this.fb.group({
      'layoutList': this.fb.array([])
    });
    this.populateLayoutListArray();
  }

  private populateLayoutListArray() {
    let layoutList = <FormArray>this.formData.controls['layoutList'];
    for (let i = layoutList.length - 1; i >= 0; i--) {
      layoutList.removeAt(i);
    }
    if (this.editMessage !== null) {
      this.svcMessageLayout.list(null, null, [{key: 'message_id', value: this.editMessage.id.toString()}]).subscribe((res2) => {
        for (let layout of res2.data){
          if (layout['flg_state'] === '0') {
            layoutList.push(this.fb.group({
              'id': layout.id,
              'ochannel_id': layout.ochannel_id,
              'message_layout_id' : layout.message_layout_id,
              'start_visibility_date' : new Date(layout.start_visibility_date),
              'end_visibility_date' : new Date(layout.end_visibility_date),
              'message_id': this.editMessage.id
            }));
          }
        }
      });
    }
  }

  addPrivacy() {
    this.layoutList = this.formData.get('layoutList') as FormArray;
    this.layoutList.push(this.fb.group({
      'id': null,
      'ochannel_id': null,
      'message_layout_id' : null,
      'start_visibility_date' : null,
      'end_visibility_date' : null,
      'message_id': this.editMessage.id
    }));
  }

  deletePrivacyList(index) {
    this.layoutList = this.formData.get('layoutList') as FormArray;
    let elem = this.layoutList.at(index).value;
    if (elem.id !== null) {
      this.svcMessageLayout.delete(elem.id).subscribe()
    }
    this.layoutList.removeAt(index);
  }

  save(index) {
    let list = this.formData.get('layoutList') as FormArray;
    let elem = list.at(index).value;
    if (elem.id === null) {
      this.svcMessageLayout.create(elem).subscribe( (res) => {
        this.layoutList = this.formData.get('layoutList') as FormArray;
        this.layoutList.at(index).value['id'] = res['id'];
      })
    } else {
      this.svcMessageLayout.update(elem).subscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/message/components/tab/layout/tabLayout.component.ts